import * as React from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button, Checkbox, message } from "antd";
import styled from "styled-components";
import { conference } from "@/api";
import {
  AnyType,
  BoolType,
  ConfefenctType,
  ConferenceInterface,
} from "@/types";
import { notChromeMessage, storage } from "@/util";
import {
  LOGININFOSTORE,
  METTINGPAGE_SAVED_MEETING_INFO,
  NORMALSETTINGKEY,
} from "@/config/const";
import { time } from "@/util";
import moment from "moment";
import userIcon from "../../../assets/images/user.svg";

const Container = styled.div`
  align-items: center;
  width: 400px;
  border-radius: 16px;
  background: white;
  justify-content: center;
  .atitle {
    display: flex;
    width: 100%;
    align-items: center;
    color: var(--Dark, #0F172A);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    padding-top: 40px;
    padding-bottom: 20px;
    justify-content: center;
  }
  .form {
    width: 280px;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;
  }
  .options {
    width: 280px;
  }
  .join {
    width: 280px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .acheck {
    margin-bottom: 10px;
  }
  .input{
    height: 35px;
    border-radius: 16px;
    border: 1px solid #ECEEF1;
    margin-top: 5px;
  }
  .tag {
    color: #374151;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: -0.12px;
    padding-left: 15px;
  }
  .buttonJoin {
    border-radius: 16px;
    background: var(--Brand-color, #00AEEF);
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #00AEEF;
    border-color: #00AEEF;
  }
`;

const QuickMeeting = () => {
  const history = useHistory();
  const [form] = Form.useForm();

  const loginfo = storage.get(LOGININFOSTORE);

  const [defaultRoom, setDefaultRoom] = React.useState(true);
  const [video, setVideo] = React.useState(false);
  const [simulcast, setSimulcast] = React.useState(false);
  //快速会议的创建时间里面的结束时间是错误的
  const createNew = async (useSelfConference: BoolType) => {
    const ret: ConferenceInterface = await conference.conferenceCreate({
      title: `${loginfo.username || loginfo.realName}-н хурал`,
      beginTime: time.format(moment()),
      endTime: time.format(moment()),
      allowEarlyEntry: BoolType.yes,
      muteJoinMeeting: BoolType.yes,
      playTips: BoolType.no,
      allowSelfUnmute: BoolType.yes,
      passwordEnable: BoolType.no,
      useSelfConference: useSelfConference,
      type:
        useSelfConference == BoolType.yes
          ? ConfefenctType.immediate
          : ConfefenctType.appointment,
      conferenceNo: loginfo.conferenceNo,
    });
    joinMeeting(ret.conferenceNo);
  };
//hubey== 进入会议
  const goMeeting = async (conf: ConferenceInterface) => {
    const settings = (storage.get(NORMALSETTINGKEY) || {}) as AnyType;
    storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
    const url = `/meeting/${conf.roomId}?username=${
      loginfo.realName
    }&audio=${!!settings.mic}&video=${video}&speaker=${!!settings.audio}&simulcast=${simulcast}`;

    history.push(url);
  };

  const joinMeeting = async (conferenceNo: string) => {
     
    // alert('kuai su ru hui  getConferenceInfo');
    const ret = await conference.conferenceJoin(
      {
        userName: loginfo.username,
        conferenceNo,
      },
      {
        "X-Conference-No": conferenceNo, //	${conferenceNo}	会议号
        "X-Device": "1", //	8
      }
    );
    const con = ret.conference as ConferenceInterface;
    con["X-Channel-Token"] = ret["X-Channel-Token"];
    con["X-Conference-Token"] = ret["X-Conference-Token"];
    con.roleCode = ret.roleCode;
    con.roleName = ret.roleName;
    if(ret.roleCode === 20){
      con.roleName= "Host";
    }
    con.roomid = ret.roomid;
   
    con.userId = ret.userid;
    goMeeting(con);
  };

  const roomIdCheckChange = async (t: any) => {
    const { checked } = t.target;
    setDefaultRoom(checked);
    const c = checked ? loginfo.conferenceNo : "";
    form.setFieldsValue({ conferenceNo: c });
  };
// 快速入会，结束时间是错误的
  const createHandler = async () => {
    const browserErrMsg = notChromeMessage();
    if (browserErrMsg) {
      message.error(browserErrMsg);
      return;
    }
    if (defaultRoom) {
      const values = await form.validateFields();
      const { conferenceNo = "" } = values as AnyType;
      createNew(BoolType.yes);
    } else {
      createNew(BoolType.no);
    }
  };

  return (
    <Container>
      <div className="atitle">Уулзалт үүсгэх</div>
      <Form form={form} className="form" labelCol={{ span: 0 }}>
        {/* <Form.Item colon={false} label=""> */}
          {/* <Checkbox checked={defaultRoom} onChange={roomIdCheckChange}> */}
          <span className="tag"> Хувийн уулзалтын ID </span> 
          {/* </Checkbox> */}
        {/* </Form.Item> */}

        {defaultRoom && (
          <Form.Item
            name="conferenceNo"
            label=""
            rules={[{ required: true }]}
            initialValue={loginfo.conferenceNo}
          >
            <Input className="input" prefix={<img className="mr3 ml3" src={userIcon} alt="userIcon" />} placeholder="Уулзалтын ID оруулна уу" disabled />
          </Form.Item>
        )}

        <Form.Item colon={false} label="">
          <Checkbox className="ml10" autoFocus={false}
            checked={video}
            onChange={(t) => setVideo(t.target.checked ? true : false)}
          >
            Камер асаах
          </Checkbox>
        </Form.Item>
        {/* <Form.Item colon={false} label="">
          <Checkbox
            checked={simulcast}
            onChange={(t) => setSimulcast(t.target.checked ? true : false)}
          >
            开启多流
          </Checkbox>
        </Form.Item> */}
        <Form.Item colon={false} label="">
          <Button type="primary" onClick={createHandler} className="w280 mb20 buttonJoin">
            Уулзалт үүсгэх
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default QuickMeeting;
